import { createPrefixer } from '.'

const ROOT = 'ver-presupuesto' as const
export const RESOURCE_PRESUPUESTO = 'Presupuesto' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_PRESUPUESTO,
    mantenimiento: {
        _perm: rp('mantenimiento'),
        bandejaPlantillas: pm('bandeja-plantila'),
        //crearPlantilla: pm('crear-plantilla'),
        verPlantilla: pm('plantilla'),
        plantillaPresupuesto: pm('plantilla-presupuesto'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        crearPresupuesto: pt('crear-presupuesto'),
        bandejaPresupuesto: pt('bandeja-presupuesto'),
        aprobacionPresupuesto: pt('aprobacion-presupuesto'),
        alcancePresupuesto: pt('alcance-presupuesto'),
        bandejaSolicitudAlcance: pt('bandeja-solicitud-alcance'),
        aprobacionAlcancePresupuesto: pt('aprobacion-alcance-presupuesto'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        crearPremisas: pc('crear-premisas'),
        bandejaPremisas: pc('bandeja-premisas'),
        nivelAprobacion: pc('nivel-aprobacion-presupuesto'),
    },
    informes: {
        _perm: rp('informes'),
        proyeccion: pi('proyeccion'),
    },
}

export default permission
